export default "__VITE_ASSET__qQ9VGfsA__"